import { useEffect, useRef } from 'react';

function useAppCable({ channel, ...restParams }, { onReceived }) {
  const { current: token } = useRef(
    document.getElementsByName('user_token')[0]?.getAttribute('content')
  );

  const memoOnReceived = useRef();
  memoOnReceived.current = onReceived;

  useEffect(() => {
    if (token?.length > 0) {
      App.initCable(token);
      App.cable.subscriptions.create(
        {
          channel,
          ...restParams,
        },
        {
          received: memoOnReceived.current,
        }
      );
    }
  }, []);
}

export default useAppCable;
